import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { clearAuthErrors, login } from '../actions/';
import autoBind from 'react-autobind';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan50 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  auth: PropTypes.object,
};

class LoginPage extends React.Component {
  constructor() {
    super();
    this.state = {
      auth: {
        email: '',
        password: '',
      },
      alertOpen: false,
      alertMessage: '',
      error: false,
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillMount() {
    this.props.dispatch(clearAuthErrors());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated) {
      browserHistory.push('/dashboard');
    }
    if (nextProps.auth.error) {
      this.setState({
        alertOpen: true,
        alertMessage: `${nextProps.auth.error.statusCode} ${nextProps.auth.error.error} ${nextProps.auth.error.message}`,
        error: true,
      });
    }
  }

  formValid() {
    return (
      this.state.auth.email !== '' &&
      this.state.auth.password !== ''
    );
  }

  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.formValid()) {
      return;
    }
    const data = {
      email: this.state.auth.email,
      password: this.state.auth.password,
    };
    this.props.dispatch(login(data));
  }

  handleChange(e) {
    const nextState = this.state.auth;
    _.set(nextState, e.target.name, e.target.value);
    this.setState({
      auth: nextState,
    });
  }

  render() {
    const fullWidth = true;
    const primary = true;
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan50,
      },
    };
    let disabled;
    if (this.formValid()) {
      disabled = false;
    } else {
      disabled = true;
    }
    return (
      <div className="auth-page" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="box">
          <h2>Sign in with your account</h2>
          <form onSubmit={this.handleSubmit}>
            <TextField
              value={this.state.auth.email}
              type="text"
              onChange={this.handleChange}
              name="email"
              fullWidth={fullWidth}
              floatingLabelText="Email"
              floatingLabelStyle={styles.cyan50}
            />
            <TextField
              value={this.state.auth.password || ''}
              type="password"
              onChange={this.handleChange}
              name="password"
              fullWidth={fullWidth}
              floatingLabelText="Password"
              floatingLabelStyle={styles.cyan50}
            />
            <RaisedButton
              disabled={disabled}
              primary={primary}
              type="submit"
              label="Login"
              fullWidth={fullWidth}
              style={{ margin: '5% 0' }}
            />
          </form>
        </div>
      </div>
    );
  }
}

LoginPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

LoginPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js